var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBox)?_c('div',{staticClass:"loading-box"},[_c('a-spin',{staticClass:"loading-child",attrs:{"tip":"Loading...","spinning":_vm.showBox}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }